
import Promise from "plugins/bluebird"

import ActionWithTimeout from "app/action_with_timeout"
import DataRetriever from "app/data_retriever"
import BrowserDetection from "app/detection/browser"

import Introjs from "plugins/introjs/index"


import I18n from "plugins/i18n-js"


const STEPS = [
  {
    element:      ".building_show_tutorial_overlay",
    intro:        I18n.t("apps_spacious_website_pages.single_commercial_building_summary_page.js.tutorial_overlay.labels.follow_button"),
    position:     "right" as const,
    tooltipClass: "introjs-last-step",
  },
]

const COMPLETED_TUTORIAL_OVERLAY_COOKIE_KEY =
  "window.App.Pages.Buildings.Show.Components.TutorialOverlay.Completed"


const init = (): Promise<unknown> => {
  return new Promise((resolve) => {
    // Tutorial should NOT be shown when follow prompt will be shown or current building is already been followed
    if (DataRetriever.get("should-show-follow-prompt") || DataRetriever.get("already-followed-by-current-user")) {
      resolve(false)
      return
    }

    return ActionWithTimeout.execute(
      COMPLETED_TUTORIAL_OVERLAY_COOKIE_KEY, 24 * 3600 * 2,
      (() => {
        // Why wait two seconds?
        return setTimeout((() => {
          if (BrowserDetection.isIE8OrLess()) { return }
          Introjs.init(STEPS)
          .then((intro_js_object) => {
            intro_js_object.start()
            resolve(true)
          })
        }), 2000)
      }),
      (() => {
        // Resolve(false) instead of reject because reject should be reserved for
        // real errors.
        return resolve(false)
      })
    )
  })
}

export default { init }
